import s from './Line.module.scss';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from "react-helmet";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import React from "react";




const Line = () => {
  const breadcrumbItems = [
    { name: 'ホーム ', link: '/' },
    { name: 'お客様の声', link: '/uservoice/line' },
    { name: 'LINEでいただいたお客様の声' },
  ];
  return (
    <div>
      <Helmet>
        <title>LINEでいただいたお客様の声</title>
        <meta property="og:title" content="LINEでいただいたお客様の声" />
        <meta property="og:image" content="https://dev.mightyaussie.com/wp-content/uploads/2019/05/LINE_thum-1-960x530.png" />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/uservoice/line`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className={"row mt-3"}>
        <div className={"col-12"}>
          <Breadcrumb items={breadcrumbItems}/>
          <div className={s.titleContainer}>
            <h2><img className={s.titleImage} src={titleImage}/>LINEでいただいたお客様の声</h2>
          </div>
        </div>
      </div>
      <div className={"row mt-3"}>
        <div className={"col-12 "}>
          <div className={s.card}>

            {/* HERO IMAGE */}
            <div className={s.hero}>
              <img
                  src="https://dev.mightyaussie.com/wp-content/uploads/2019/05/LINE_thum-1-960x530.png"
                  alt="line画像"
              />
            </div>

            {/* IMAGE GRID (MODERN) */}
            <div className={s.gallery}>
              <img src="http://dev.mightyaussie.com/wp-content/uploads/2019/05/uv1@2x-687x1024.png" />
              <img src="http://dev.mightyaussie.com/wp-content/uploads/2019/05/uv2@2x-687x1024.png" />
              <img src="http://dev.mightyaussie.com/wp-content/uploads/2019/05/uv3@2x-687x1024.png" />
              <img src="http://dev.mightyaussie.com/wp-content/uploads/2019/05/uv4@2x-687x1024.png" />
              <img src="http://dev.mightyaussie.com/wp-content/uploads/2019/05/uv10@2x-687x1024.png" />
              <img src="http://dev.mightyaussie.com/wp-content/uploads/2019/05/uv11@2x-687x1024.png" />
              <img src="http://dev.mightyaussie.com/wp-content/uploads/2019/05/uv12@2x-687x1024.png" />
              <img src="http://dev.mightyaussie.com/wp-content/uploads/2023/11/IMG_8673-e1700545900921-687x1024.png" />
            </div>

            {/* GOOGLE REVIEW BLOCK (KEEP SAME CONTENT) */}
            <div className={s.splitSection}>
              <div className={s.splitLeft}>
                <img src="https://dev.mightyaussie.com/wp-content/uploads/2019/07/googlemap@2x-300x169.png" />
              </div>
              <div className={s.splitRight}>
                <h3>Googleマップからのクチコミも受付中です！</h3>
                <p>Googleマップのクチコミも数多くいただいておりますので、ぜひご覧ください！</p>

                <a className={s.button} href="https://goo.gl/maps/QCfNnfCCe8s">
                  Googleマップのクチコミを見る
                </a>
              </div>
            </div>

            {/* COMMENTS (MODERN FEED STYLE) */}
            <div className={s.commentsSection}>
              <h3 className={s.sectionTitle}>その他いただいたコメント</h3>

              <div className={s.commentGrid}>

                <div className={s.commentCard}>
                  <img className={s.avatar} src="https://secure.gravatar.com/avatar/2ffea99bea8657144530066fa0e2d822?s=90&d=mm&r=g" />
                  <div>
                    <div className={s.name}>ひでき</div>
                    <div className={s.date}>2024年8月17日</div>
                    <p className={s.text}>大自然動物ツアーに参加しました...</p>
                  </div>
                </div>

                <div className={s.commentCard}>
                  <img className={s.avatar} src="https://secure.gravatar.com/avatar/1263421a0f404a0a58c6755f54e89f3b?s=90&d=mm&r=g" />
                  <div>
                    <div className={s.name}>小原浩二</div>
                    <div className={s.date}>2024年7月6日</div>
                    <p className={s.text}>6/26にグリーン島とアウターリーフツアー...</p>
                  </div>
                </div>

                {/* repeat same structure for others */}
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  );
};

export default Line;
